// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a6e0443","952":"0b6e1e8e"}[chunkId] + ".chunk.js";
};